import { Icon } from "antd";
import styled from "styled-components";

const IconStyled = styled(Icon)`
  color: ${(props) => props.color ?? props.theme.icon.color};
  margin: ${(props) => props.margin ?? props.theme.icon.margin};
`;

export default IconStyled;
